export function mobileMenu() {
	const mobileMenuBtn = document.getElementById('mobilemenubtn');
	const mobileMenu = document.getElementById('mobilemenu');

	mobileMenuBtn.addEventListener('click', () => {
		mobileMenuBtn.classList.toggle('active');
		mobileMenu.classList.toggle('active');
	});

	// Sluiten bij klikken buiten het menu
	document.addEventListener('click', (e) => {
		if (!mobileMenu.contains(e.target) && !mobileMenuBtn.contains(e.target)) {
			mobileMenuBtn.classList.remove('active');
			mobileMenu.classList.remove('active');
		}
	});

	// ✅ Sluiten wanneer je op een link in het menu klikt
	mobileMenu.querySelectorAll('a').forEach((link) => {
		link.addEventListener('click', () => {
			mobileMenuBtn.classList.remove('active');
			mobileMenu.classList.remove('active');
		});
	});
}